"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
const ApiClient_1 = require("../lib/ApiClient");
var ContentPriceSubjectTypeEnum;
(function (ContentPriceSubjectTypeEnum) {
    ContentPriceSubjectTypeEnum["CONTENT_SET"] = "content_set";
    ContentPriceSubjectTypeEnum["MESSAGE_ATTACHMENT"] = "message_attachment";
    ContentPriceSubjectTypeEnum["VAULT_FILE"] = "vault_file";
})(ContentPriceSubjectTypeEnum = exports.ContentPriceSubjectTypeEnum || (exports.ContentPriceSubjectTypeEnum = {}));
exports.isContentPurchaseNotificationDetails = (details) => {
    var _a;
    return ((_a = details) === null || _a === void 0 ? void 0 : _a[ApiClient_1.typenameSymbol]) === "ContentPurchaseNotificationDetails";
};
class ContentPriceProvider extends DataProvider_1.default {
    get fragments() {
        return {
            ContentPrice: () => `
        ... on ContentPrice {
          subject {
            ${this.getFragment("Subject")}
          }
          packageId
        }`,
            ContentPurchaseDetails: () => `
      ... on ContentPurchaseDetails {
        id
        userId
        user {
          ${this.getFragment("UserPublicData")}
        }
        subject {
          ${this.getFragment("Subject")}
        }
        time
      }
      `,
            NotificationDetails: () => `
        ... on ContentPurchaseNotificationDetails {
          contentType
          content {
            __typename
            ${this.getFragment("SubjectDetails")}
          }
          amount
          costs {
            ${this.getFragment("CurrencyCost")}
          }          
        }
      `,
        };
    }
    search({ subjects }) {
        return this.query("contentPriceFind", { subjects }, this.getFragment("ContentPrice"));
    }
    searchPurchases({ data }) {
        return this.query("contentPurchaseSearch", { data }, this.getPageableFragment("ContentPurchaseDetails"));
    }
    update({ data }) {
        return this.mutate("contentPriceUpdate", { data }, this.getFragment("ContentPrice"));
    }
    purchase({ data }) {
        return this.mutate("contentPurchase", { data }, this.getFragment("ContentPurchaseDetails"));
    }
}
exports.ContentPriceProvider = ContentPriceProvider;
//# sourceMappingURL=ContentPriceProvider.js.map